import a1 from './a1'
import a2 from './a2'
import a3 from './a3'
import a4 from './a4'
import s1 from './s1'
import m2 from './m2'
import m3 from './m3'
import m4 from './m4'
import m5 from './m5'
import m6 from './m6'
import m7 from './m7'
import m8 from './m8'
import m9 from './m9'
import m10 from './m10'

// Map of tour key -> definition. Backend ships canonical metadata for each tour
// (audience, isAutoStartEnabled, displayOrder, stepCount); definitions here add the FE-only
// pieces: which route to navigate to, and the per-step CSS target + i18n strings.
export default {
  A1: a1,
  A2: a2,
  A3: a3,
  A4: a4,
  S1: s1,
  M2: m2,
  M3: m3,
  M4: m4,
  M5: m5,
  M6: m6,
  M7: m7,
  M8: m8,
  M9: m9,
  M10: m10,
}
